import React, { FC, useMemo, useState } from 'react';
import { useFilters } from '../contexts/FiltersContext';
import DateTimePickerModal from './DateTimePickerModal';

interface HeaderProps { pageTitle: string }

const fmtRuDateTime = (d: Date) => {
    const pad = (n: number) => String(n).padStart(2,'0');
    const dd = pad(d.getDate());
    const mm = pad(d.getMonth()+1);
    const yy = String(d.getFullYear()).slice(-2);
    const hh = pad(d.getHours());
    const mi = pad(d.getMinutes());
    return `${dd}.${mm}.${yy} ${hh}:${mi}`;
};

const StatusChip: FC<{ label: string; color: string; stations: string[] }> = ({ label, color, stations }) => {
    const [hover, setHover] = useState(false);
    const count = stations.length;
    const tooltip = useMemo(() => stations.join(', '), [stations]);
    return (
        <div
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, cursor: 'default' }}
        >
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: color }}></span>
            <span style={{ color }}>{label}</span>
            <span style={{ color }}>({count})</span>
            {hover && count > 0 && (
                <div style={{
                    position: 'absolute', top: '120%', right: 0, maxWidth: 280,
                    background: '#2C2C2C', color: '#fff', border: '1px solid #3a3b3f', borderRadius: 8,
                    padding: '8px 10px', boxShadow: '0 8px 20px -6px rgba(0,0,0,0.7)', whiteSpace: 'normal', zIndex: 20
                }}>
                    {tooltip}
                </div>
            )}
        </div>
    );
};

export const Header: FC<HeaderProps> = ({ pageTitle }) => {
        const { dateFrom, dateTo, setDateRange, statusOverview } = useFilters();
        const [openFrom, setOpenFrom] = useState(false);
        const [openTo, setOpenTo] = useState(false);

    return (
                <header style={{
            display: 'flex',
            alignItems: 'center',
                        padding: '0 24px',
            background: '#1A2030',
            color: '#fff',
            position: 'fixed',
            top: 0,
            left: 60,
            right: 0,
            height: 60,
            zIndex: 5,
            borderBottom: '1px solid #2A2B2F',
            boxShadow: '0 4px 10px -4px rgba(0,0,0,0.6)',
            backdropFilter: 'blur(2px)'
        }}>
                        <h1 style={{ fontSize: 20, fontWeight: 500, margin: 0 }}>{pageTitle}</h1>
                        {/* Global filters pushed to the right */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 'auto', minWidth: 0 }}>
                            <span style={{ color:'#bbb', fontSize:14 }}>с</span>
                            <button
                                onClick={()=>setOpenFrom(true)}
                                style={{ background:'#424F67', color:'#fff', border:'1px solid #2F3136', borderRadius:4, height:28, padding:'4px 12px', fontSize:14, display:'flex', alignItems:'center', justifyContent:'space-between', width:260, gap:8 }}
                            >
                                <span style={{ color:'#fff' }}>{fmtRuDateTime(dateFrom)}</span>
                                <span style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="2" y="3" width="12" height="11" rx="2" stroke="#888" strokeWidth="1"/>
                                        <path d="M5 1V4" stroke="#888" strokeWidth="1" strokeLinecap="round"/>
                                        <path d="M11 1V4" stroke="#888" strokeWidth="1" strokeLinecap="round"/>
                                        <path d="M3 6H13" stroke="#888" strokeWidth="1" strokeLinecap="round"/>
                                    </svg>
                                </span>
                            </button>
                            <span style={{ color:'#bbb', fontSize:14 }}>по</span>
                            <button
                                onClick={()=>setOpenTo(true)}
                                style={{ background:'#424F67', color:'#fff', border:'1px solid #2F3136', borderRadius:4, height:28, padding:'4px 12px', fontSize:14, display:'flex', alignItems:'center', justifyContent:'space-between', width:260, gap:8 }}
                            >
                                <span style={{ color:'#fff' }}>{fmtRuDateTime(dateTo)}</span>
                                <span style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="2" y="3" width="12" height="11" rx="2" stroke="#888" strokeWidth="1"/>
                                        <path d="M5 1V4" stroke="#888" strokeWidth="1" strokeLinecap="round"/>
                                        <path d="M11 1V4" stroke="#888" strokeWidth="1" strokeLinecap="round"/>
                                        <path d="M3 6H13" stroke="#888" strokeWidth="1" strokeLinecap="round"/>
                                    </svg>
                                </span>
                            </button>
                        </div>

                        {/* Status overview with counts; show station list on hover */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 24, minWidth: 0, marginLeft: 16 }}>
                            {statusOverview.map(s => (
                                <StatusChip key={s.label} label={s.label} color={s.color} stations={s.stations} />
                            ))}
                        </div>

                        {/* Date pickers */}
                        <DateTimePickerModal
                            isOpen={openFrom}
                            initialDate={dateFrom}
                            onClose={()=>setOpenFrom(false)}
                            onSelect={(d)=> setDateRange(d, dateTo)}
                            label="С даты"
                        />
                        <DateTimePickerModal
                            isOpen={openTo}
                            initialDate={dateTo}
                            onClose={()=>setOpenTo(false)}
                            onSelect={(d)=> setDateRange(dateFrom, d)}
                            label="По дату"
                        />
        </header>
    );
};